'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalHistoryDetail = rentalHistoryDetail;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalHistoryDetail() {
    var clazz = function RentalHistoryDetail() {
        var defaults = {
            id: null,
            version: 0,
            productId: 0,
            productName: '',
            productImagePath: '',
            sellerArticleNumber: '',
            serialNumber: '',
            startDate: null,
            endDate: null,
            remark: '',
            deposit: 0,
            status: {},
            shippingNoteNumber: '',
            depositRefunded: null,
            depositRefundedDate: null,
            dailyRentalPrice: 0,
            totalRent: 0,
            rentPerMonth: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        calculateRentPerPeriod: function calculateRentPerPeriod(startDate, endDate) {
            if (this.status.code !== '50') {
                var daysBetween = endDate.diff(startDate, 'days') + 1;
                return daysBetween * this.dailyRentalPrice;
            }
            return 0;
        },
        isCancelled: function isCancelled() {
            return this.status.code === '50';
        }
    });

    clazz.create = function (resource) {
        var item = new clazz();
        item.id = resource.id;
        item.version = resource.version;
        item.productId = resource.productId;
        item.productName = resource.productName;
        item.productImagePath = resource.productImagePath;
        item.sellerArticleNumber = resource.sellerArticleNumber;
        item.serialNumber = resource.serialNumber;
        item.startDate = resource.startDate;
        item.endDate = resource.endDate;
        item.remark = resource.remark;
        item.status = {
            id: resource.status.id,
            code: resource.status.code,
            name: resource.status.name
        }, item.shippingNoteNumber = resource.shippingNoteNumber;
        item.deposit = resource.deposit;
        item.depositRefunded = resource.depositRefunded;
        item.depositRefundedDate = resource.depositRefundedDate;
        item.dailyRentalPrice = resource.dailyRentalPrice;
        item.isCancelled = item.isCancelled();
        if (item.isCancelled) {
            item.totalRent = 0;
            item.rentPerMonth = [];
        } else if (item.startDate && item.dailyRentalPrice) {
            var startDay = (0, _moment2.default)(item.startDate, 'YYYY-MM-DD');
            var endDay = void 0;
            if (item.endDate) {
                endDay = (0, _moment2.default)(item.endDate, 'YYYY-MM-DD');
            } else {
                endDay = (0, _moment2.default)().startOf('day');
            }
            if (!startDay.isSame(endDay)) {
                item.totalRent = item.calculateRentPerPeriod(startDay, endDay);

                var rentPerMonth = [];
                var day = (0, _moment2.default)(startDay).startOf('month');
                while (day.isSameOrBefore(endDay)) {
                    rentPerMonth.push({
                        month: (0, _moment2.default)(day)
                    });
                    day.add(1, 'month');
                }

                if ((0, _moment2.default)(day).subtract(1, 'day').isSame(endDay)) {
                    rentPerMonth.push({
                        month: (0, _moment2.default)(day)
                    });
                }

                rentPerMonth.forEach(function (i) {
                    var start = _moment2.default.max(startDay, (0, _moment2.default)(i.month).subtract(1, 'day'));
                    var end = _moment2.default.min((0, _moment2.default)(i.month).add(1, 'month').subtract(2, 'day'), endDay);
                    var rent = item.calculateRentPerPeriod(start, end);
                    var month = i.month.format('MMMM YYYY');

                    if (rent > 0) {
                        item.rentPerMonth.push({ rent: rent, month: month });
                    }
                });
            }
        }
        return item;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/rentalHistoryDetailModel.js
// module id = 780
// module chunks = 0